//
import { COMANDA_ABERTA } from '../../shared/constants';
import Comanda from '../../shared/entity/Comanda';
import React, { useEffect, useState } from 'react';
import { Alert, Dimensions, StyleSheet, Text, View } from 'react-native';
import { Button as PaperButton, Dialog, Portal, TextInput } from 'react-native-paper';
import comandaApi from '../../apis/comandaApi';
import colors from '../../colors';
import { MAX_WIDTH_MODAL, TXT_M } from '../../constants';
import { useEmpresa } from '../../redux/empresa/empresaHooks';
import { useSessao } from '../../redux/sessao/sessaoHooks';
import Button from '../Generic/Button';
import CModal from '../Generic/CModal';
import CTextInput from '../Generic/CTextInput';
import { CustomPicker } from '../Generic/CustomPicker';
import Divider from '../Generic/Divider';
import Title from '../Generic/Title';

const DEVICE_WIDTH = Dimensions.get('window').width;

type Props = {
  comanda?: Comanda;
  setComanda: (x: Comanda) => void;
};

const SelecaoComanda: React.FC<Props> = (props) => {
  const { comanda, setComanda } = props;
  const [comandas, setComandas] = useState([]);
  const [sessao] = useSessao();
  const [empresa] = useEmpresa();
  const [novaComanda, setNovaComanda] = useState(new Comanda());

  const [mostrarModal, setMostrarModal] = useState(false);

  const buscarComandas = async () => {
    const response = await comandaApi.getMany({
      where: { status: COMANDA_ABERTA },
      relations: ['pedidos']
    });
    console.log('response', response);
    setComandas(response);
  };

  const salvarNovaComanda = async () => {
    try {
      const response = await comandaApi.insert(novaComanda);
      await buscarComandas();
      setComanda(response);
    } catch (err) {
      Alert.alert('Erro', err.data ?? 'Erro ao cadastrar comanda.');
    }
  };

  useEffect(() => {
    buscarComandas();
  }, []);

  if (!sessao.token) {
    return null;
  }

  return (
    <View>
      <CModal mostrarModal={mostrarModal} onClose={() => setMostrarModal(false)}>
        <Dialog.Title>Nova Comanda</Dialog.Title>
        <Dialog.Content>
          <CTextInput
            label={'Nome da comanda'}
            placeholder={'Ex.: MESA 10'}
            onChangeText={(txt) => setNovaComanda({ ...novaComanda, nome: txt })}
            value={novaComanda.nome}
          />
        </Dialog.Content>
        <Dialog.Actions style={{ justifyContent: 'space-around' }}>
          <PaperButton onPress={() => setMostrarModal(false)} mode={'text'}>
            Cancelar
          </PaperButton>

          <PaperButton
            onPress={() => {
              salvarNovaComanda();
              setMostrarModal(false);
            }}
            mode={'contained'}
            color={colors.green}
            dark={true}
          >
            Salvar
          </PaperButton>
        </Dialog.Actions>
      </CModal>

      <Title style={{ marginBottom: 10 }}>Comanda:</Title>

      <CustomPicker
        list={comandas}
        onChange={(comanda) => setComanda(comanda)}
        value={comanda}
        getItemLabel={(comanda) => comanda.nome}
      />

      <Text style={{ alignSelf: 'center', marginTop: 5, marginBottom: 5 }}>OU</Text>

      <Button onPress={() => setMostrarModal(true)} title={'+ NOVA COMANDA'}></Button>

      <Divider style={{ marginBottom: 10, marginTop: 10 }} />
    </View>
  );
};

const styles = StyleSheet.create({
  radioLabel: {
    fontSize: TXT_M,
    color: colors.darkGrey
  },
  viewTaxa: {
    flexDirection: 'row',
    alignSelf: 'center',
    marginTop: 15,
    justifyContent: 'center',
    alignItems: 'center'
  },
  labelTaxa: { marginRight: 5, fontSize: TXT_M, color: colors.primary },
  valorTaxa: { fontSize: TXT_M, color: colors.values },
  selectView: {
    borderWidth: 2,
    borderColor: colors.lightGrey,
    borderRadius: 5
  },
  select: {
    borderWidth: 0,
    padding: 5
    // backgroundColor: '#ff0'
    // WebkitAppearance: 'none',
    // '-moz-appearance': none,
    // textIndent: 1
    // // text-overflow: '',
  }
});

export default SelecaoComanda;
